export default __webpack_public_path__ + "static/banner-bg-f78dfc34bf82c1dcc88e5c0d25e7aa2c.png";